var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaunch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 1.5H7.875C6.10724 1.5 5.22335 1.5 4.67417 2.04917C4.125 2.59835 4.125 3.48224 4.125 5.25V12.75C4.125 14.5178 4.125 15.4016 4.67417 15.9508C5.22335 16.5 6.10724 16.5 7.875 16.5H10.125C11.8928 16.5 12.7766 16.5 13.3258 15.9508C13.875 15.4016 13.875 14.5178 13.875 12.75V5.25C13.875 3.48224 13.875 2.59835 13.3258 2.04917C12.7766 1.5 11.8928 1.5 10.125 1.5Z",
    stroke: "#00424B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09375 14.25H9M9.1875 14.25C9.1875 14.3536 9.10357 14.4375 9 14.4375C8.89643 14.4375 8.8125 14.3536 8.8125 14.25C8.8125 14.1464 8.89643 14.0625 9 14.0625C9.10357 14.0625 9.1875 14.1464 9.1875 14.25Z",
    stroke: "#00424B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/launch.88a32510e08d52187f12c08487af5ad7.svg";
export { ForwardRef as ReactComponent };